import { html, LitElement } from 'lit';
import { customElement } from 'lit/decorators.js';
import { WEB_COMPONENT_RISK_SCAN_ACTION } from '../../../../../webcomponents.constants';
import { translateFn } from '../../../../../utils/translator.helper';
import { FontSizes } from '../../../../../types/common/types';

@customElement(WEB_COMPONENT_RISK_SCAN_ACTION)
export class GzRiskScanActionWebComponent extends LitElement {
  protected render() {
    return html`<gz-text fontSize="${FontSizes.HEADING_6}">
      ${translateFn('You are about to create a task that will scan the selected endpoints for risks.')}
    </gz-text>`;
  }
}
